import { render, staticRenderFns } from "./FreeTrial.vue?vue&type=template&id=2fdc6ffb"
import script from "./FreeTrial.vue?vue&type=script&lang=js"
export * from "./FreeTrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports